export const generateUniqId13 = () => {
    const timePart = Date.now().toString(36); // base-36 timestamp
    const randomPart = Math.random()
        .toString(36)
        .substring(2, 13 - timePart.length);
    return (timePart + randomPart).padEnd(13, "0");
};
